import React from "react";
import {
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TableContainer,
  Box,
  IconButton,
  Button,
} from "@mui/material";
import {
  IAutomobileDriverInformation,
  IDriverLicenseHistory,
} from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import { ExtendableSelect } from "../../../../../../../components/formsComponents/ExtendableSelect";
import { FormikErrors } from "formik";
import { CustomDatePicker } from "../../../../../../../components/formsComponents/CustomDatePicker";
import {
  ControlledCustomSelect,
  CustomTextField,
} from "../../../../../../../components/formsComponents";
import { Add, Remove } from "@mui/icons-material";
import { ICommAutomobileDriverInformation } from "../../../../../../../redux/commAutoPolicy/commAutoDriver/commAutoDriver.types";
import {
  AUTOMOBILE_CSIO_LICENSE_STATUS_REVERSE,
} from "../../../../../../../constants/csioConstants";
import { licenseClasses } from "../../../../../../../constants/constants";

interface LicenseHistoryTableProps {
  values: IAutomobileDriverInformation | ICommAutomobileDriverInformation;
  isDisable?: boolean;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) =>
    | Promise<
        FormikErrors<
          IAutomobileDriverInformation | ICommAutomobileDriverInformation
        >
      >
    | any;
  onAddNewLicenseHistory: (currentIndex: number) => void;
  onRemoveLicenseHistory: (index: number) => void;
  onLicenseHistoryRowChange: (
    key: keyof IDriverLicenseHistory,
    rowIndex: number,
    value: string
  ) => void;
  errors?: any;
}

const LicenseHistoryTable: React.FC<LicenseHistoryTableProps> = ({
  values,
  isDisable,
  setFieldValue,
  errors,
  onAddNewLicenseHistory,
  onRemoveLicenseHistory,
  onLicenseHistoryRowChange,
}) => {
  const handleLicenseHistoryRowChange =
    (key: keyof IDriverLicenseHistory, rowIndex: number) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onLicenseHistoryRowChange(key, rowIndex, event.target.value);
    };

  const handleLicenseHistorySelectChange =
    (key: keyof IDriverLicenseHistory, rowIndex: number) =>
    (event: SelectChangeEvent<any>) => {
      onLicenseHistoryRowChange(key, rowIndex, event.target.value);
    };

  // const handleCurrencyRowChange =
  //   (key: keyof IInsuranceLapse, rowIndex: number) => (newValue: string) => {
  //     onInsuranceLapseRowChange(key, rowIndex, newValue);
  //   };

  const handleRemoveLicenseHistoryRow = (index: number) => () => {
    onRemoveLicenseHistory(index);
  };

  const handleLicenseHistoryNewRow = (currentRowIndex: number) => () => {
    onAddNewLicenseHistory(currentRowIndex);
  };

  return (
    // <Grid container spacing={1}>
    //   <Grid item xs={12} md={12}>

    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography fontWeight={600} variant="h5">
                #
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={600} variant="h5">
                Class Name
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "15%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                License Status
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "15%" }}>
              <Typography fontWeight={600} variant="h5">
                Date First Licensed
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "20%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                License Number
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "15%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                Years Licensed
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "20%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                Current License Country
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "20%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                Province/State
              </Typography>
            </TableCell>
           
            <TableCell sx={{ width: "15%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                License Expiry Date
              </Typography>
            </TableCell>
            <TableCell sx={{ width: "15%" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                License Type
              </Typography>
            </TableCell>
            
            <TableCell>
              <Box display={"flex"}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleLicenseHistoryNewRow(
                    (values.license_history || []).length + 1
                  )}
                  disabled={isDisable}
                >
                  <Add fontSize="small" />
                </Button>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(values.license_history || []).map((item, index) => {
            return (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>
                  <Typography fontWeight={600} variant="h5">
                    {index + 1}
                  </Typography>
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <ExtendableSelect
                    value={item.class}
                    onChange={(newValue) => {
                      handleLicenseHistorySelectChange(
                        "class",
                        index
                      )({
                        target: {
                          value: newValue,
                        },
                      } as any);
                    }}
                    placeholder="Select"
                    options={licenseClasses}
                    disabled={isDisable}
                    error={
                      errors?.license_history?.[index]?.class ? true : false
                    }
                    errorMessage={errors?.license_history?.[index]?.class}
                  />
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <ControlledCustomSelect
                    fullWidth
                    value={item.license_status}
                    name="license_status"
                    onChange={handleLicenseHistorySelectChange(
                      "license_status",
                      index
                    )}
                    disabled={isDisable}
                    placeholder="Select one"
                    displayEmpty
                    options={AUTOMOBILE_CSIO_LICENSE_STATUS_REVERSE.map(
                      (template) => {
                        return { label: template, value: template };
                      }
                    )}
                    helperText={
                      errors?.license_history?.[index]?.license_status
                    }
                    error={
                      errors?.license_history?.[index]?.license_status
                        ? true
                        : false
                    }
                  ></ControlledCustomSelect>
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <CustomDatePicker
                    fullWidth
                    value={item.date_first_licensed || ""}
                    onChange={(newValue) =>
                      onLicenseHistoryRowChange(
                        "date_first_licensed",
                        index,
                        newValue
                      )
                    }
                    disabled={isDisable}
                    errorMessage={
                      errors?.license_history?.[index]?.date_first_licensed
                    }
                  />
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <CustomTextField
                    id="country"
                    variant="outlined"
                    size="small"
                    type="text"
                    fullWidth
                    disabled={isDisable}
                    value={item.license_number}
                    onChange={handleLicenseHistoryRowChange(
                      "license_number",
                      index
                    )}
                    helperText={
                      errors?.license_history?.[index]?.license_number
                    }
                    error={
                      errors?.license_history?.[index]?.license_number
                        ? true
                        : false
                    }
                  />
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <CustomTextField
                    id="country"
                    variant="outlined"
                    size="small"
                    type="text"
                    fullWidth
                    disabled={isDisable}
                    value={item.year_licensed}
                    onChange={handleLicenseHistoryRowChange(
                      "year_licensed",
                      index
                    )}
                    helperText={errors?.license_history?.[index]?.year_licensed}
                    error={
                      errors?.license_history?.[index]?.year_licensed
                        ? true
                        : false
                    }
                  />
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <CustomTextField
                    id="country"
                    variant="outlined"
                    size="small"
                    type="text"
                    fullWidth
                    disabled
                    value={item.current_license_country}
                    onChange={handleLicenseHistoryRowChange(
                      "current_license_country",
                      index
                    )}
                    helperText={
                      errors?.license_history?.[index]?.current_license_country
                    }
                    error={
                      errors?.license_history?.[index]?.current_license_country
                        ? true
                        : false
                    }
                  />
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <ControlledCustomSelect
                    fullWidth
                    value={item.province_or_state}
                    name="province_or_state"
                    onChange={handleLicenseHistorySelectChange(
                      "province_or_state",
                      index
                    )}
                    disabled={isDisable}
                    placeholder="Select one"
                    displayEmpty
                    options={[
                      "AB",
                      "BC",
                      "MB",
                      "NB",
                      "NL",
                      "NS",
                      "NT",
                      "NU",
                      "ON",
                      "PE",
                      "QC",
                      "SK",
                      "YT",
                    ].map((template) => {
                      return { label: template, value: template };
                    })}
                    helperText={
                      errors?.license_history?.[index]?.province_or_state
                    }
                    error={
                      errors?.license_history?.[index]?.province_or_state
                        ? true
                        : false
                    }
                  ></ControlledCustomSelect>
                </TableCell>
                
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <CustomDatePicker
                    fullWidth
                    disabled={isDisable}
                    value={item.license_expiry_date || ""}
                    onChange={(newValue) =>
                      onLicenseHistoryRowChange(
                        "license_expiry_date",
                        index,
                        newValue
                      )
                    }
                    // errorMessage={errors?.license_history?.[index]?.license_expiry_date}
                  />
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", minWidth: "250px" }}>
                  <ControlledCustomSelect
                    fullWidth
                    value={item.license_type}
                    name="license_type"
                    onChange={handleLicenseHistorySelectChange(
                      "license_type",
                      index
                    )}
                    disabled={isDisable}
                    placeholder="Select one"
                    displayEmpty
                    options={[
                      "Ministry of Environment",
                      "Explosives",
                      "Radioactive or Nuclear Material",
                      "Room Capacity",
                      "Watercraft Operator",
                      "Automobile Operator",
                      "Liquor",
                      "Elevator",
                      "Innkeepers'",
                      "Rooming House",
                      "Healthcare",
                      "Teaching Facility",
                      "Sale of Firearms",
                      "Other",
                    ].map((template) => {
                      return { label: template, value: template };
                    })}
                    helperText={errors?.license_history?.[index]?.license_type}
                    error={
                      errors?.license_history?.[index]?.license_type
                        ? true
                        : false
                    }
                  ></ControlledCustomSelect>
                </TableCell>{" "}
                
                <TableCell sx={{ verticalAlign: "top", minWidth: "100px" }}>
                  <Box display={"flex"}>
                    <IconButton
                      color="error"
                      disabled={isDisable}
                      onClick={handleRemoveLicenseHistoryRow(
                        index
                        // handleRemoveInsuranceLapseRow(value.column.rowIndex
                      )}
                    >
                      <Remove fontSize="small" />
                    </IconButton>
                    <IconButton
                      color="primary"
                      disabled={isDisable}
                      onClick={handleLicenseHistoryNewRow(index)}
                    >
                      <Add fontSize="small" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>

    //   </Grid>
    // </Grid>
  );
};

export default LicenseHistoryTable;
